function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#8A3AB9"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.31 15.121c0-.686-.558-1.244-1.244-1.244-.686 0-1.245.558-1.245 1.244a1.246 1.246 0 0 0 2.489 0zM15.066 12.124a2.98 2.98 0 0 1 1.735.555h4.514v-.88a3.16 3.16 0 0 0-3.156-3.155h-6.316A3.16 3.16 0 0 0 8.687 11.8v.88h4.644a2.98 2.98 0 0 1 1.735-.556zm2.586-1.562c0-.193.158-.35.351-.35h1.084c.193 0 .35.157.35.35v1.083c0 .193-.157.351-.35.351h-1.084a.352.352 0 0 1-.35-.35v-1.084z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.064 15.121a3.001 3.001 0 0 1-2.998 2.998 3.001 3.001 0 0 1-2.713-4.271H8.687v4.32a3.16 3.16 0 0 0 3.156 3.155h6.316a3.16 3.16 0 0 0 3.156-3.155v-4.32H17.78c.182.387.285.818.285 1.273z",
  fill: "#fff"
});

var SvgInstagramRedesign = function SvgInstagramRedesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "228c41dbf35d6dab392b85f68f0e4d91.svg";
export { SvgInstagramRedesign as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/instagram-redesign.svg
// module id = null
// module chunks = 